export const abCampaignEvent = ({ testName, variationId, variationName }) => ({
  type: 'Flagship Test',
  data: {
    'Test Name': testName,
    VariationID: variationId,
    VarationName: variationName,
  },
});
